import { Payment } from '@melio/platform-api';
import { noop } from 'lodash';
import { createContext } from 'react';

export const LoanDrawerContext = createContext<{
  onViewPayment: ({ id }: { id: Payment['id'] }) => void;
}>({
  onViewPayment: noop,
});
